module.exports = __webpack_public_path__ + "static/media/clickableQuestions.aba65ed6.mp4";